<template>
  <div>
    <template v-if="hasPreview">
      <div v-if="isValidImage">
        <v-card class="align-stretch d-flex">
          <v-img :src="fileData.link"/>
        </v-card>
      </div>
      <div v-if="isValidVideo">
        <video-player :src="fileData.link" :extension="fileData.extension"/>
      </div>
      <div v-else>
        <iframe v-if="isPdf" :src="fileData.link" width="100%" height="500px"/>
      </div>
    </template>
    <div v-else class="text-center py-12">
      <v-icon size="50" color="grey lighten-1">mdi-file-document</v-icon>
      <h3>Preview not available</h3>
    </div>
  </div>
</template>

<script>
  import VideoPlayer from '@/views/tasks/components/VideoPlayer'
  export default {
    components: {
      VideoPlayer
    },
    name: 'SimpleFilePreview',

    props: ['fileData'],

    computed: {
      isValidImage () {
        return this.fileData.extension === '.jpeg' || this.fileData.extension === '.jpg' || this.fileData.extension === '.png'
      },
      isPdf () {
        return this.fileData.extension === '.pdf'
      },
      hasPreview () {
        const validExtensions = ['.mov', '.mp4', '.jpeg', '.jpg', '.png', '.pdf', '.xls', '.xlsx', '.md', '.pptx']
        return validExtensions.includes(this.fileData.extension)
      },
      isValidVideo () {
        return this.fileData.extension === '.mp4' || this.fileData.extension === '.mov'
      }
    }
  }
</script>
